<div class="html-container">
    <html-renderer class="html-content" #renderer
                   [htmlCode]="htmlCode"
                   [cssStyles]="cssStyles"
                   [containerClass]="containerClass"></html-renderer>

    <div class="html-edition-buttons-container"
         [ngClass]="{'shrink': renderer?.htmlContainer?.nativeElement.clientHeight <= 40}">
        <div class="html-edition-buttons">
            <p-button label="Edit" icon="pi pi-pencil"
                      styleClass="p-button-outlined"
                      [title]="editionButtonHint ?? ''"
                      (onClick)="showEditDialog()"></p-button>
        </div>
    </div>
</div>

<p-dialog [(visible)]="editDialogVisible"
          [header]="editDialogHeader"
          [maximizable]="true"
          [resizable]="true"
          [modal]="true"
          position="top"
          styleClass="html-editor-dialog"
          (onHide)="cancelHtmlCodeChanges()">
    <ng-template pTemplate="content">
        <div class="html-editor-container">
            <div class="grid">
                <div class="col-6">
                    <div class="html-editor">
                        <p-tabView>
                            <p-tabPanel header="HTML">
                                <html-editor [(ngModel)]="htmlCodeEdition">
                                </html-editor>
                            </p-tabPanel>
                            <p-tabPanel header="CSS">
                                <css-editor [(ngModel)]="cssStylesEdition">
                                </css-editor>
                            </p-tabPanel>
                        </p-tabView>
                    </div>
                </div>
                <div class="col-6">
                    <div class="html-preview">
                        <h4>Preview</h4>
                        <div class="html-preview-content">
                            <html-renderer [htmlCode]="htmlCodeEdition"
                                           [cssStyles]="cssStylesEdition"
                                           [containerClass]="containerClass"></html-renderer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-footer>
            <p-button label="Cancel"
                      icon="pi pi-times"
                      styleClass="secondary-button"
                      (onClick)="cancelHtmlCodeChanges()"></p-button>
            <p-button label="Save"
                      icon="pi pi-check"
                      (onClick)="saveHtmlCodeChanges()"></p-button>
        </p-footer>
    </ng-template>
</p-dialog>